import { cva as e } from "class-variance-authority";
// src/design/timeline/style.ts
var t = e("flex flex-col gap-0", {
	variants: { size: {
		sm: "gap-0",
		md: "gap-0",
		lg: "gap-0",
		xl: "gap-0"
	} },
	defaultVariants: { size: "md" }
}), n = e("flex gap-3 relative items-start", {
	variants: { size: {
		sm: "gap-2",
		md: "gap-3",
		lg: "gap-4",
		xl: "gap-5"
	} },
	defaultVariants: { size: "md" }
}), r = e("flex flex-col items-center flex-shrink-0", {
	variants: { size: {
		sm: "w-6",
		md: "w-8",
		lg: "w-10",
		xl: "w-12"
	} },
	defaultVariants: { size: "md" }
}), i = e("absolute inset-y-0 w-px border-l border-border z-0", {
	variants: { variant: {
		subtle: "border-border/50",
		solid: "border-border",
		outline: "border-border",
		plain: "border-transparent"
	} },
	defaultVariants: { variant: "solid" }
}), a = e("flex items-center justify-center rounded-full shrink-0 border border-border bg-back z-20 relative", {
	variants: {
		size: {
			sm: "h-6 w-6 text-xs",
			md: "h-8 w-8 text-sm",
			lg: "h-10 w-10 text-base",
			xl: "h-12 w-12 text-md"
		},
		variant: {
			subtle: "bg-muted border-border text-muted-foreground",
			solid: "bg-filter-bg border-filter-border text-primary-foreground",
			outline: "bg-back border-filter-border text-foreground",
			plain: "bg-back border-border/50 text-muted-foreground"
		}
	},
	defaultVariants: {
		size: "md",
		variant: "solid"
	}
}), o = e("flex flex-col flex-1", {
	variants: { size: {
		sm: "gap-0.5 pb-4",
		md: "gap-1 pb-6",
		lg: "gap-1.5 pb-8",
		xl: "gap-2 pb-10"
	} },
	defaultVariants: { size: "md" }
}), s = e("font-medium text-foreground", {
	variants: { size: {
		sm: "text-sm",
		md: "text-base",
		lg: "text-md",
		xl: "text-lg"
	} },
	defaultVariants: { size: "md" }
}), c = e("text-muted-foreground", {
	variants: { size: {
		sm: "text-xs",
		md: "text-sm",
		lg: "text-base",
		xl: "text-md"
	} },
	defaultVariants: { size: "md" }
}), l = (e) => ({
	root: (n) => t({
		size: e?.size,
		...n
	}),
	item: (t) => n({
		size: e?.size,
		...t
	}),
	connector: (t) => r({
		size: e?.size,
		...t
	}),
	separator: (t) => i({
		variant: e?.variant,
		...t
	}),
	indicator: (t) => a({
		size: e?.size,
		variant: e?.variant,
		...t
	}),
	content: (t) => o({
		size: e?.size,
		...t
	}),
	title: (t) => s({
		size: e?.size,
		...t
	}),
	description: (t) => c({
		size: e?.size,
		...t
	})
});
export { r as connectorStyles, o as contentStyles, c as descriptionStyles, l as getStyles, a as indicatorStyles, n as itemStyles, t as rootStyles, i as separatorStyles, s as titleStyles };

//# sourceMappingURL=style.js.map